import React, { ReactNode } from 'react'

import Box from 'components_new/atoms/Box'
import Skeleton from 'components_new/atoms/Skeleton'
import Text, { TextProps } from 'components_new/atoms/Text'

import IconTip from 'components_new/molecules/IconTip'

import { SxProps } from '@mui/material'

export interface LabelItemProps {
  align?: TextProps['align']
  children: ReactNode
  label: string
  loading?: boolean
  sx?: SxProps
  tooltip?: ReactNode
}

const LabelItem = React.forwardRef((props: LabelItemProps, ref: any) => {
  const { align, children, label, loading, sx, tooltip } = props

  return (
    <Box
      ref={ref}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        textAlign: align === 'right' ? 'right' : 'left',
        ...sx
      }}
    >
      <Text
        color="text.secondary"
        component="div"
        noWrap={true}
        variant="caption"
      >
        {loading ? (
          <Skeleton
            variant="text"
            width={32}
            sx={{ lineHeight: 1, mb: '0.375em' }}
          />
        ) : (
          <>
            {label}
            {tooltip ? (
              <IconTip size="xsmall" sx={{ ml: 0.25 }} title={tooltip} />
            ) : null}
          </>
        )}
      </Text>

      <Box
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          justifyContent: 'center'
        }}
      >
        {children}
      </Box>
    </Box>
  )
})

export default LabelItem
